import type { RouteObject } from 'react-router';
import { SchedulerPage } from './pages/SchedulerPage';
import { ScheduleShareViewPage } from './pages/ScheduleShareViewPage';
import { ForemanConfirmRespondPage } from './pages/ForemanConfirmRespondPage';
import { VendorOrderReplyPage } from './pages/share/VendorOrderReplyPage';
import { VendorDeliveryPage } from './pages/share/VendorDeliveryPage';
import { VendorOrderListPage } from './pages/share/VendorOrderListPage';

export const routes: RouteObject[] = [
  { path: '/agents/scheduler', Component: SchedulerPage },
];

// 외부공유 수신자 뷰어 (F-04 §7) — 고정 경로, shareType과 일치 (회원 인증 없음)
export const shareRoutes: RouteObject[] = [
  { path: 'share/SCHEDULE_SHARE', Component: ScheduleShareViewPage },
  { path: 'share/FOREMAN_CONFIRM', Component: ForemanConfirmRespondPage },
  // 거래처 발주 회신(C-3-1)·배송정보 등록(C-4-1) — WP5 4단계
  { path: 'share/SUPPLIER_ORDER_REPLY', Component: VendorOrderReplyPage },
  { path: 'share/SUPPLIER_DELIVERY', Component: VendorDeliveryPage },
  // 받은 발주 목록(거래처·사업장 단위 토큰, E-15) — 건별 화면(회신·배송정보)으로 이동
  { path: 'share/SUPPLIER_ORDER_LIST', Component: VendorOrderListPage },
];
